import React from 'react';

const Divider = ({ additionalStyle = "", children }) => (
    <div
      className={`w-full lg:max-w-[1000px] text-center mx-auto 
      border-y-[1px] text-lg md:text-3xl px-4 py-8 ${additionalStyle}`}
    >
      {children}
    </div>
  );

export default Divider;